import "../edit.css";
import { DividerProps } from "./divider.props";

export const Divider: React.FC<DividerProps> = ({ text }) => {
  return (
    <div className="edit-divider">
      {text !== undefined && text.length > 0 ? <p>{text}</p> : <div />}
    </div>
  );
};
